import React, { Component, Fragment } from "react";
import "./LiveData.less";
import http from "../../../utils/api";
import { Tabs, message } from "antd";
import EditNotice from "../EditNotice";
import ApproveList from "../ApproveList";
import ApproveProjectList from "../ApproveProjectList";
import UploadFile from "../UploadFile/UploadFile";
const { TabPane } = Tabs;

class LiveData extends Component {
  state = {
    auth: "",
  };
  componentDidMount = () => {
    this.getAuth();
  };
  getAuth = async () => {
    let res;
    try {
      res = await http().getTable({
        resid: 650458953643,
      });
      this.setState({
        auth:
          res.data &&
          res.data.data &&
          res.data.data[0] &&
          res.data.data[0].auth,
      });
    } catch (error) {
      message.error(error.message);
    }
  };

  render() {
    const { auth } = this.state;
    return auth === "admin" ? (
      <Tabs
        defaultActiveKey="1"
        tabBarStyle={{
          height: "70px",
          display: "flex",
          alignItems: "center",
          paddingLeft: "50px",
        }}
      >
        <TabPane tab="上传资料" key="1">
          <UploadFile
            hasNoDelete={true}
            mode="live"
            resid={650393662160}
          ></UploadFile>
        </TabPane>
        <TabPane tab="下载资料" key="2">
          <UploadFile
            hasNoUpload={true}
            mode="live"
            resid={650393662160}
          ></UploadFile>
        </TabPane>
      </Tabs>
    ) : (
      <Tabs
        defaultActiveKey="1"
        tabBarStyle={{
          height: "70px",
          display: "flex",
          alignItems: "center",
          paddingLeft: "50px",
        }}
      >
        {auth === "upload" ? (
          <TabPane tab="上传资料" key="1">
            <UploadFile
              hasNoDelete={true}
              mode="live"
              resid={650393662160}
            ></UploadFile>
          </TabPane>
        ) : auth === "download" ? (
          <TabPane tab="下载资料" key="2">
            <UploadFile
              hasNoUpload={true}
              mode="live"
              resid={650393662160}
            ></UploadFile>
          </TabPane>
        ) : (
          <TabPane tab="无权限" key="3"></TabPane>
        )}
      </Tabs>
    );
  }
}

export default LiveData;
